import React, { useEffect, useState } from "react"
import IntlProps from "../../../state/helpers/IntlProps"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import CustomFieldService from "../../../state/custom-fields/CustomFieldService"
import { SelectOption } from "../../../state/helpers/SelectOption"
import Select from "react-select"
import DeprecatedUserSelect from "../../../common/user/selection.component.jsx"
import LoadingSpinner from "../../../common/spinner/loading.component"
import ActionButton from "../../../common/button/actionbutton.component"
import ConfirmButton from "../../../common/button/confirmbutton.component"
import { Link } from "react-router-dom"
import Toggle from "react-toggle"
import FeatureToggleComponent from "../FeatureToggleComponent"

const messages = defineMessages({
    "submit_btn": {
        id: "integration.form.edit.submit_btn",
        defaultMessage: "Save",
    },
    "choose_option": {
        id: "integration.form.edit.choose_option",
        defaultMessage: "Choose",
    },
    "contact_email": {
        id: "integration.form.edit.contact_email",
        defaultMessage: "Email",
    },
    "contact_name": {
        id: "integration.form.edit.contact_name",
        defaultMessage: "Full Name",
    },
    "contact_last_name": {
        id: "integration.form.edit.contact_last_name",
        defaultMessage: "Last Name",
    },
    "contact_first_name": {
        id: "integration.form.edit.contact_first_name",
        defaultMessage: "First Name",
    },
    "quote_notes": {
        id: "integration.form.edit.contact_notes",
        defaultMessage: "Notes",
    },
    "contact_phone_number": {
        id: "integration.form.edit.contact_phone_number",
        defaultMessage: "Phone Number",
    },
    "contact_address": {
        id: "integration.form.edit.contact_address",
        defaultMessage: "Address",
    },
    "contact_organization": {
        id: "integration.form.edit.contact_organization",
        defaultMessage: "Organization",
    },
    "contact_country": {
        id: "integration.form.edit.contact_country",
        defaultMessage: "Country",
    },
    "all-pages": {
        id: "integration.form.edit.all_pages",
        defaultMessage: "All pages",
    },
    "on-cart-view": {
        id: "integration.form.edit.on_cart_view",
        defaultMessage: "On cart view",
    },
    "checkout-section": {
        id: "integration.form.edit.checkout_section",
        defaultMessage: "Checkout Section",
    },
    "quote_po_number": {
        id: "integration.form.edit.quote_po_number",
        defaultMessage: "Quote Po Number",
    },
    "button_option_left": {
        id: "integration.form.edit.button_option_left",
        defaultMessage: "Left",
    },
    "button_option_right": {
        id: "integration.form.edit.button_option_right",
        defaultMessage: "Right",
    },
    "button_option_center": {
        id: "integration.form.edit.button_option_center",
        defaultMessage: "Center",
    },
})

type OwnProps = {
    configuration,
    integrationKey: string,
    authConnect: string
    enabledFeatures: object,
    submitIntegration: (formOptions: object) => void
    submitButtonIsEnabled: () => boolean
    deleteIntegration: () => void
    onFeatureToggled: (featureKey: string) => void,
    onConfigurationChange: (configuration: object) => void,
}

const LSEcomFormComponent = (props: OwnProps & IntlProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [formOptions, setFormOptions] = useState({
        inputFormValues: [] as SelectOption[],
        requiredFields: [] as SelectOption[],
        buttonVisibility: [],
        buttonClassName: "",
        textAfterSubmission: "",
        buttonPlaceHolder: "",
        formSendButtonLabel: "",
        formCancelButtonLabel: "",
        buttonLabel: "",
        formTitle: "",
        inputFormOptions: [] as SelectOption[],
        inputRequiredOptions: [] as SelectOption[],
        buttonVisibilityOptions: [] as SelectOption[],
        userId: "",
        buttonPosition: "",
    })

    useEffect(() => {
        Promise.all([
            CustomFieldService.getAvailableFor("quotes"),
            AppContext.getApiClient().get("/" + props.integrationKey + "/form-options")
        ]).then(([customFields, res]) => {
            const defaultValues = [
                { value: "contact-name", label: props.intl.formatMessage(messages["contact_name"]), type: "text" },
                { value: "contact-email", label: props.intl.formatMessage(messages["contact_email"]), type: "text" },
                {
                    value: "contact-phoneNumbers",
                    label: props.intl.formatMessage(messages["contact_phone_number"]),
                    type: "text"
                },
                {
                    value: "quote-externalNotes",
                    label: props.intl.formatMessage(messages["quote_notes"]),
                    type: "multi-line-text"
                }
            ]

            const inputValues =
                res && res.attributes &&
                    res.attributes.formInputParameters &&
                    res.attributes.formInputParameters.length > 0 ?
                    res.attributes.formInputParameters.sort((a, b) =>
                        (a.sortingOrder > b.sortingOrder) ? 1 : -1).map(elem => {
                        return { "value": elem.key, "label": elem.label }
                    })
                    : defaultValues

            const requiredFields =
                res && res.attributes &&
                    res.attributes.formInputParameters &&
                    res.attributes.formInputParameters.length > 0 ?
                    res.attributes.formInputParameters.filter(elem => elem.isRequired).map(elem => {
                        return { "value": elem.key, "label": elem.label }
                    })
                    : defaultValues

            const inputFormOptions = [
                { value: "contact-name", label: props.intl.formatMessage(messages["contact_name"]), type: "text" },
                { value: "contact-email", label: props.intl.formatMessage(messages["contact_email"]), type: "text" },
                {
                    value: "contact-country",
                    label: props.intl.formatMessage(messages["contact_country"]),
                    type: "single-choice"
                },
                {
                    value: "quote-externalNotes",
                    label: props.intl.formatMessage(messages["quote_notes"]),
                    type: "multi-line-text"
                },
                {
                    value: "contact-firstName",
                    label: props.intl.formatMessage(messages["contact_first_name"]),
                    type: "text"
                },
                {
                    value: "contact-organizationName",
                    label: props.intl.formatMessage(messages["contact_organization"]),
                    type: "text"
                },
                {
                    value: "contact-lastName",
                    label: props.intl.formatMessage(messages["contact_last_name"]),
                    type: "text"
                },
                {
                    value: "contact-phoneNumbers",
                    label: props.intl.formatMessage(messages["contact_phone_number"]),
                    type: "text"
                },
                { value: "contact-address", label: props.intl.formatMessage(messages["contact_address"]), type: "text" },
                ...customFields.map((f) => ({
                    value: "quote-customField-" + f.getId(),
                    label: f.getName(),
                    type: f.getFieldType(),
                    customFieldId: f.getId()
                }))
            ]

            const visibilityOptions = [
                { value: "checkout-section", label: props.intl.formatMessage(messages["checkout-section"]) },
                { value: "on-cart-view", label: props.intl.formatMessage(messages["on-cart-view"]) },
                { value: "all-pages", label: props.intl.formatMessage(messages["all-pages"]) }
            ]

            setFormOptions({
                inputFormValues: inputValues,
                requiredFields: requiredFields,
                buttonVisibility: res.attributes.buttonVisibility ? res.attributes.buttonVisibility.map(elem => {
                    return { "value": elem, "label": props.intl.formatMessage(messages[elem]) }
                }) : [],
                buttonPosition: res.attributes.buttonPosition,
                buttonClassName: res.attributes.buttonClassName,
                textAfterSubmission: res.attributes.textAfterSubmission,
                buttonPlaceHolder: res.attributes.buttonPlaceHolder,
                formSendButtonLabel: res.attributes.formSendButtonLabel,
                formCancelButtonLabel: res.attributes.formCancelButtonLabel,
                buttonLabel: res.attributes.buttonLabel,
                formTitle: res.attributes.formTitle,
                inputRequiredOptions: inputValues,
                userId: res.attributes.userId,
                inputFormOptions: inputFormOptions,
                buttonVisibilityOptions: visibilityOptions,
            })
        }).then(() => {
            setIsLoading(false)
        })
    }, [])

    const renderFormOptions = () => {
        const ButtonVisibilityOptions = formOptions.buttonVisibilityOptions
        const InputFormOptions = formOptions.inputFormOptions.map(elem => {
            return { "value": elem.value, "label": elem.label }
        })
        const buttonPositionOptions = [
            { value: "right", label: props.intl.formatMessage(messages["button_option_right"]) },
            { value: "left", label: props.intl.formatMessage(messages["button_option_left"]) },
            { value: "middle", label: props.intl.formatMessage(messages["button_option_center"]) },
        ]
        const selectAttributes = {
            "inputFormValues": { options: InputFormOptions, multi: true },
            "requiredFields": { options: formOptions.inputRequiredOptions, multi: true },
            "buttonVisibility": { options: ButtonVisibilityOptions, multi: true },
            "buttonPosition": { options: buttonPositionOptions, multi: false },
        }
        const inputAttributes = [
            "buttonClassName",
            "textAfterSubmission",
            "buttonPlaceHolder",
            "formSendButtonLabel",
            "formCancelButtonLabel",
            "buttonLabel",
            "formTitle",
        ]

        const selectElements = Object.entries(selectAttributes).map(([elem, value]) => {
            return <div className="form-group row" key={elem}>
                <label className="col-3 col-form-label text-align-right" htmlFor={elem}>
                    {renderConfigurationValueLabel(elem)}
                </label>
                <div className="col-9">
                    <Select
                        multi={value.multi}
                        value={formOptions[elem]}
                        onChange={value => {
                            const formOptionsCopy = Object.assign({}, formOptions)
                            formOptionsCopy[elem] = value
                            const inputFormValues = formOptionsCopy.inputFormValues.map(elem => elem.value)
                            const inputFormOptions = formOptionsCopy.inputFormOptions.filter(elem =>
                                inputFormValues.includes(elem.value))
                            const requiredFields = formOptionsCopy.requiredFields.filter(elem =>
                                inputFormValues.includes(elem.value))

                            formOptionsCopy["inputRequiredOptions"] = inputFormOptions
                            formOptionsCopy["requiredFields"] = requiredFields
                            setFormOptions(
                                formOptionsCopy,
                            )
                        }}
                        options={selectAttributes[elem].options}
                        clearable={false}
                    />
                </div>
            </div>
        })

        const inputElements = inputAttributes.map(elem => {
            return <div className="form-group row" key={elem}>
                <label className="col-3 col-form-label text-align-right" htmlFor={elem}>
                    {renderConfigurationValueLabel(elem)}
                </label>
                <div className="col-9">
                    <input className="col-12"
                        onChange={e => {
                            setFormOptions({
                                ...formOptions,
                                [elem]: e.target.value
                            })
                        }}
                        value={formOptions[elem]}
                        required autoFocus />
                </div>
            </div>

        })
        return <div>
            {selectElements}
            <div className="form-group row" key="user-select">
                <label className="col-3 col-form-label text-align-right" htmlFor="userId">
                    <FormattedMessage
                        id="calendar.new_event.user_label"
                        defaultMessage="Assigned to"
                    />
                    <span className="text-danger">*</span>
                </label>
                <div className="col-9">
                    <DeprecatedUserSelect
                        multi={false}
                        value={formOptions.userId}
                        onChange={(userId: string) => {
                            setFormOptions({
                                ...formOptions,
                                userId: userId,
                            })
                        }}
                        clearable={false}
                    />
                </div>
            </div>
            {inputElements}
        </div>
    }

    const addVariablesToPayload = () => {
        const sentParameters = {}
        const inputFormValues = formOptions.inputFormValues.map(elem => elem.value)
        let inputFormOptions = formOptions.inputFormOptions.filter(elem => inputFormValues.includes(elem.value))
        const requiredFields = formOptions.requiredFields.map(elem => elem.value)
        inputFormOptions = inputFormOptions.map(elem => {
            if (requiredFields.includes(elem.value)) {
                return { ...elem, "isRequired": true, "sortingOrder": inputFormValues.indexOf(elem.value) }
            } else {
                return { ...elem, "isRequired": false, "sortingOrder": inputFormValues.indexOf(elem.value) }
            }
        })
        sentParameters["hash"] = props.configuration.hash
        sentParameters["formOptions"] = {
            inputFormOptions: inputFormOptions,
            buttonPosition: formOptions.buttonPosition,
            buttonVisibility: formOptions.buttonVisibility,
            buttonClassName: formOptions.buttonClassName,
            textAfterSubmission: formOptions.textAfterSubmission,
            buttonPlaceHolder: formOptions.buttonPlaceHolder,
            formSendButtonLabel: formOptions.formSendButtonLabel,
            formCancelButtonLabel: formOptions.formCancelButtonLabel,
            buttonLabel: formOptions.buttonLabel,
            formTitle: formOptions.formTitle,
        }
        props.submitIntegration(sentParameters)
    }
    const getFormFooter = (): JSX.Element => {
        return <div className="row">
            <div className="col-6">
                <ConfirmButton
                    onClick={() => props.deleteIntegration()}
                    className="btn btn-danger">
                    <FormattedMessage
                        id="integration.form.edit.delete_btn"
                        defaultMessage="Delete integration"
                    />
                </ConfirmButton>
            </div>
            <div className="col-6 text-align-right">
                <Link to="/integrations/listing" className="btn btn-light">
                    <FormattedMessage
                        id="integration.form.edit.cancel_btn"
                        defaultMessage="Cancel"
                    />
                </Link>
                &nbsp;
                &nbsp;
                {
                    !props.authConnect &&
                    <ActionButton
                        disabled={!props.submitButtonIsEnabled}
                        onClick={() => addVariablesToPayload()} type="submit" className="btn btn-primary">
                        {props.intl.formatMessage(messages["submit_btn"])}
                    </ActionButton>
                }
            </div>
        </div>
    }

    return !isLoading ? <>
        <div className="col-12 ui-module">
            <div className="form-group row">
                <label className="col-3 col-form-label text-align-right" htmlFor="lsEcomAccountId">
                    <FormattedMessage
                        id="integration.form.edit.lightspeed.account_id"
                        defaultMessage="Account ID"
                    />
                </label>
                <div className="col-9">
                    <input
                        name="accountId"
                        value={props.configuration.accountId}
                        disabled={true}
                        id="accountId"
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="form-group row">
                <label className="col-3 col-form-label text-align-right" htmlFor="mainDomain">
                    <FormattedMessage
                        id="integration.form.edit.lightspeed.main_domain"
                        defaultMessage="Main Domain"
                    />
                </label>
                <div className="col-9">
                    <input
                        name="mainDomain"
                        value={props.configuration.mainDomain}
                        disabled={true}
                        id="mainDomain"
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="form-group row">
                <label className="col-3 col-form-label text-align-right" htmlFor="configurationShowHidden">
                    <FormattedMessage
                        id="integration.form.edit.lightspeed.import_hidden_products"
                        defaultMessage="Import Hidden Products"
                    />
                </label>
                <div className="col-9 d-flex align-items-center">
                    <Toggle
                        checked={props.configuration.showHiddenProducts}
                        defaultChecked={props.configuration.showHiddenProducts}
                        icons={false}
                        onChange={() => {
                            props.onConfigurationChange({
                                ...props.configuration,
                                ...{ showHiddenProducts: !props.configuration.showHiddenProducts },
                            })
                        }}
                    />
                </div>
            </div>
            {renderFeatureToggles(props)}
            {renderFormOptions()}
        </div>
        <div className="col-12 ui-module">
            {getFormFooter()}
        </div>
    </> :
        <div className="col-12 ui-module">
            <LoadingSpinner />
        </div>

}

const renderFeatureToggles = (props: OwnProps) => {
    return Object.keys(props.enabledFeatures).map((featureKey, i) => {
        if (featureKey === "payment-sync") { // invoice and payment are sync together now
            return
        }

        return <FeatureToggleComponent
            key={i}
            featureKey={featureKey}
            checked={props.enabledFeatures[featureKey]}
            onFeatureToggled={() => {
                props.onFeatureToggled(featureKey)
            }}
            renderFeatureLabel={renderFeatureLabel}

        />
    })
}

const renderFeatureLabel = (key: string) => {
    switch (key) {
    case "product-import-ignore-sku-matching":
        return <FormattedMessage
            id="integration.form.edit.feature_toggle.product_import_ignore_sku_matching"
            defaultMessage="SKUs are not unique"
        />
    default:
        return key
    }

}

const renderConfigurationValueLabel = (key: string) => {
    switch (key) {
    case "inputFormValues":
        return <FormattedMessage
            id="integration.form.edit.ls_ecom.input_form_values"
            defaultMessage="Form Options"
        />
    case "requiredFields":
        return <FormattedMessage
            id="integration.form.edit.ls_ecom.required_fields"
            defaultMessage="Required Fields"
        />
    case "buttonVisibility":
        return <FormattedMessage
            id="integration.form.edit.ls_ecom.button_visibility"
            defaultMessage="Quote Button Visibility"
        />
    case "buttonClassName":
        return <FormattedMessage
            id="integration.form.edit.ls_ecom.button_className"
            defaultMessage="Button ClassName"
        />
    case "textAfterSubmission":
        return <FormattedMessage
            id="integration.form.edit.ls_ecom.text_after_submission"
            defaultMessage="Text After Form Submission"
        />
    case "buttonPlaceHolder":
        return <FormattedMessage
            id="integration.form.edit.ls_ecom.button_placeHolder"
            defaultMessage="Button Placeholder"
        />
    case "formSendButtonLabel":
        return <FormattedMessage
            id="integration.form.edit.ls_ecom.formSendButtonLabel"
            defaultMessage="Form Send Button Label"
        />
    case "formCancelButtonLabel":
        return <FormattedMessage
            id="integration.form.edit.ls_ecom.formCancelButtonLabel"
            defaultMessage="Form Cancel Button Label"
        />
    case "buttonLabel":
        return <FormattedMessage
            id="integration.form.edit.ls_ecom.buttonLabel"
            defaultMessage="Request Quote Button Label"
        />
    case "formTitle":
        return <FormattedMessage
            id="integration.form.edit.ls_ecom.formTitle"
            defaultMessage="Form Title"
        />
    case "buttonPosition":
        return <FormattedMessage
            id="integration.form.edit.ecom.request_button_position_label"
            defaultMessage="Button Position"
        />
    default:
        return key
    }
}

export default injectIntl(LSEcomFormComponent)




// WEBPACK FOOTER //
// ./src/integration/form/ls-ecom/LSEcomFormComponent.tsx